import texts from './sharedmoments/sharedmoments.texts'

class HomeController {
    constructor($scope) {
        this.name = 'home'

        this.$scope = $scope
    }

    $onInit() {
        this.render()

        this.watchLanguage()
    }

    render() {
        this.language = localStorage.getItem('tourists_lang') || 'EN'

        const {
            BEEN_IN_GEORGIA,
            ARE_YOU_CONTRIBUTOR_ONE,
            ARE_YOU_CONTRIBUTOR_TWO
        } = texts[this.language]

        this.beenInGeorgia = BEEN_IN_GEORGIA
        this.areYouContributorOne = ARE_YOU_CONTRIBUTOR_ONE
        this.areYouContributorTwo = ARE_YOU_CONTRIBUTOR_TWO
    }

    watchLanguage() {
        this.$scope.$watch(() => localStorage.getItem('tourists_lang'), (newValue, oldValue) => {
            if (newValue && newValue !== oldValue) {
                this.render()
            }
        })
    }
}

HomeController.$inject = ['$scope']

export default HomeController



// WEBPACK FOOTER //
// ./client/app/components/home/home.controller.js